import api from '../lib/api';
import type { Paginated } from '../types';
import type { Product, ProductInput } from '../types/crm';

// Single-record endpoints return `{ data: { id, type, attributes: {...} } }`;
// list endpoints return flat records. See operator.service.ts for the rationale.

export const productService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<Product>> => {
    const response = await api.get<Paginated<Product>>('/products', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Product> => {
    const response = await api.get<{ data: { attributes: Product } }>(`/products/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: ProductInput): Promise<Product> => {
    const response = await api.post<{ data: { attributes: Product } }>('/products', { product: data });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<ProductInput>): Promise<Product> => {
    const response = await api.patch<{ data: { attributes: Product } }>(`/products/${id}`, { product: data });
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/products/${id}`);
  },
};

export default productService;
